export default __webpack_public_path__ + "static/media/image-colon.e750216e.png";